// src/pages/WartungsprotokollPage.jsx  

import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import WartungsprotokollSeite1 from "./wartungsprotokoll/WartungsprotokollSeite1";
import WartungsprotokollSeite2 from "./wartungsprotokoll/WartungsprotokollSeite2";
import WartungsprotokollSeite3 from "./wartungsprotokoll/WartungsprotokollSeite3";
import WartungsprotokollSeite4 from "./wartungsprotokoll/WartungsprotokollSeite4";
import WartungsprotokollSeite5 from "./wartungsprotokoll/WartungsprotokollSeite5";
import WartungsprotokollSeite6 from "./wartungsprotokoll/WartungsprotokollSeite6";
import WartungsprotokollSeite7 from "./wartungsprotokoll/WartungsprotokollSeite7";
import WartungsprotokollSeite8 from "./wartungsprotokoll/WartungsprotokollSeite8";
import WartungsprotokollSeite9 from "./wartungsprotokoll/WartungsprotokollSeite9";
import WartungsprotokollSeite10 from "./wartungsprotokoll/WartungsprotokollSeite10";
import WartungsprotokollSeite11 from "./wartungsprotokoll/WartungsprotokollSeite11";
import WartungsprotokollSeite11b from "./wartungsprotokoll/WartungsprotokollSeite11b";
import WartungsprotokollSeite12 from "./wartungsprotokoll/WartungsprotokollSeite12";


export default function WartungsprotokollPage() {



  const navigate = useNavigate();

  const [seite1, setSeite1] = useState({
    kundeId: "",   // 👈 add here
    vorgang: "",
    anlagenbezeichnung: "",
    anlagenName: "",
    wartungspaket: "",

    dcMessungen: false,
    dcNurBeiUnregelmaessigkeiten: false,
    dcVollstaendigOderBereich: "",
    vollstaendigGemaessDin: false,

    acMessungen: false,
    acNurBeiUnregelmaessigkeiten: false,
    acVollstaendigOderBereich: "",

    zentralwechselrichter: false,
    mittelspannungsanlagenErweitert: false,
    erdungsmessungenStationen: false,
    sichtpruefungMittelspannungsanlagen: false,

    reinigung: false,
    reinigungWr: false,
    reinigungGak: false,
    reinigungModule: false,

    thermografie: false,
    thermografieVerteiler: false,
    thermografieModule: false,
    thermografieMspAnlagen: false,

    kennlinienmessungen: false,

    ersatzpunkt1: "",
    ersatzpunkt2: "",
    ersatzpunkt3: ""
  });

  const [seite2, setSeite2] = useState({
    zugangsschluesselVorhanden: false,
    zugangsschluesselAnmerkung: "",
    thermoKameraVorhanden: false,
    thermoKameraAnmerkung: "",

    betreiberKontaktiert: false,
    betreiberAnmerkung: "",
    eigentuemerKontaktiert: false,
    eigentuemerAnmerkung: "",

    elektrofachkraftName: "",
    arbeitszeiten: [
      { datum: "", name: "", beginn: "", ende: "", stunden: "", wetter: "", temperatur: "" }
    ]
  });

  const [seite3, setSeite3] = useState({
    // SECTION 1 (1.1–1.3)
    verschattung: [
      { ja: false, nein: false, nz: false },
      { ja: false, nein: false, nz: false },
      { ja: false, nein: false, nz: false }
    ],

    // ZUSATZ-TABELLE #1
    zusatz1: [
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false },
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false },
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false },
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false },
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false }
    ],

    // SECTION 2 (2.1–2.9)
    anlageZustand: Array.from({ length: 9 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    verschmutzungLeicht: false,
    verschmutzungMittel: false,
    verschmutzungStark: false,
    verschmutzungPartiell: false,
    verschmutzungFlaechig: false,
    verschmutzungRand: false,

    reinigungEmpfohlenJa: false,
    reinigungEmpfohlenNein: false,

    // ZUSATZ-TABELLE #2
    zusatz2: [
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false },
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false },
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false },
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false },
      { zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false }
    ]
  });

  const [seite4, setSeite4] = useState({
    pruefungMontage: Array.from({ length: 10 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    zusatz1: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    })),

    sichtkontrolle: Array.from({ length: 4 }).map(() => ({
      ja: false,
      nein: false,
      nz: false,
      sbm: false
    })),

    zusatz2: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    }))
  });

  const [seite5, setSeite5] = useState({

    // SECTION 5 (5.1–5.5)
    messungenPV: Array.from({ length: 5 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    // ZUSATZ-TABELLE #1
    zusatz1: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    })),

    // SECTION 6 (6.1–6.13)
    pruefungGAKs: Array.from({ length: 13 }).map(() => ({
      ja: false,
      nein: false,
      nz: false,
      sbm: false,
      sbeiblatt: false
    })),

    // ZUSATZ-TABELLE #2
    zusatz2: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    }))
  });

  const [seite6, setSeite6] = useState({

    // SECTION 7 (7.1–7.14)
    pruefungWR: Array.from({ length: 14 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    // ZUSATZ-TABELLE #1
    zusatzWR: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    })),

    // SECTION 8 (8.1–8.13)
    pruefungAC: Array.from({ length: 13 }).map(() => ({
      ja: false,
      nein: false,
      nz: false,
      sbm: false,
      sbeiblatt: false
    })),

    // ZUSATZ-TABELLE #2
    zusatzAC: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    }))
  });

  const [seite7, setSeite7] = useState({

    // SECTION 9 (9.1–9.4)
    pruefungZaehler: Array.from({ length: 4 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    // ZUSATZ-TABELLE #1
    zusatzZaehler: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    })),

    // SECTION 10 (10.1–10.12)
    pruefungUeberwachung: Array.from({ length: 10 }).map(() => ({
      ja: false,
      nein: false,
      nz: false,
    })),

    // ZUSATZ-TABELLE #2
    zusatzUeberwachung: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    }))
  });

  const [seite8, setSeite8] = useState({
    // SECTION 11 (11.1–11.9)
    pruefungAussen: Array.from({ length: 9 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    // ZUSATZ-TABELLE #1
    zusatzAussen: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    })),

    // SECTION 12 (12.1–12.5)
    pruefungDiebstahl: Array.from({ length: 5 }).map(() => ({
      ja: false,
      nein: false,
      nz: false,
      sbm: false,
      sbeiblatt: false
    })),

    // ZUSATZ-TABELLE #2
    zusatzDiebstahl: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    }))
  });

  const [seite9, setSeite9] = useState({
    // SECTION 13 (13.1–13.23)
    pruefungWRZentral: Array.from({ length: 23 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    // ZUSATZ-TABELLE
    zusatzWRZentral: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    }))
  });

  const [seite10, setSeite10] = useState({
    // SECTION 14 (14.1–14.28)
    pruefungMSP: Array.from({ length: 29 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    // ZUSATZ-TABELLE
    zusatzMSP: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    }))
  });

  const [seite11, setSeite11] = useState({
    // SECTION 15 (15.1–15.4)
    pruefungMSsicht: Array.from({ length: 4 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    // ZUSATZ-TABELLE #1
    zusatzMSsicht: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    })),

    // SECTION 16 (16.1–16.4)
    sonstiges: Array.from({ length: 4 }).map(() => ({
      ja: false,
      nein: false,
      nz: false
    })),

    // ZUSATZ-TABELLE #2
    zusatzSonstiges: Array.from({ length: 5 }).map(() => ({
      zupunkt: "",
      bemerkung: "",
      standort: "",
      plan: false,
      bildnr: "",
      beh: false,
      nbeh: false
    }))
  });

  const [seite11b, setSeite11b] = useState({
    // Schulnoten 1–6
    noten: Array(6).fill(false),

    // Abschluss der Arbeiten (6 booleans)
    abschluss: Array(6).fill(false),

    // 6 x Anmerkungen
    anmerkungen: Array(6).fill(""),

    // Anzahl Beiblätter
    anzahlBeiblaetter: "",

    // final confirmation
    allesErledigt: false,

    // date + signature
    datum: "",
    unterschrift: ""
  });

  const [seite12, setSeite12] = useState({
    empfehlungen: Array.from({ length: 12 }).map(() => ({
      zunr: "",
      empfehlung: "",
      sicherheit: false,
      ertrag: false,
      erhaltung: false,
      kosten: ""
    }))
  });



  const { id } = useParams();   // ← 1) right here

  // 2) load existing protocol if ID is present
  useEffect(() => {
    if (!id) return;

    async function load() {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/wartungsprotokoll/${id}`);
      const data = await res.json();

      setSeite1(data.seite1);
      setSeite2(data.seite2);
      setSeite3({
        verschattung: data.seite3?.verschattung ?? Array.from({ length: 3 }, () => ({ ja: false, nein: false, nz: false })),
        anlageZustand: data.seite3?.anlageZustand ?? Array.from({ length: 9 }, () => ({ ja: false, nein: false, nz: false })),

        verschmutzungLeicht: data.seite3?.verschmutzungLeicht ?? false,
        verschmutzungMittel: data.seite3?.verschmutzungMittel ?? false,
        verschmutzungStark: data.seite3?.verschmutzungStark ?? false,
        verschmutzungPartiell: data.seite3?.verschmutzungPartiell ?? false,
        verschmutzungFlaechig: data.seite3?.verschmutzungFlaechig ?? false,
        verschmutzungRand: data.seite3?.verschmutzungRand ?? false,

        reinigungEmpfohlenJa: data.seite3?.reinigungEmpfohlenJa ?? false,
        reinigungEmpfohlenNein: data.seite3?.reinigungEmpfohlenNein ?? false,

        zusatz1: (data.seite3?.zusatz1 ?? Array.from({ length: 5 }, () => ({ zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false }))).map(r => ({ ...r })),
        zusatz2: (data.seite3?.zusatz2 ?? Array.from({ length: 5 }, () => ({ zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false }))).map(r => ({ ...r })),
      });
      setSeite4(data.seite4);
      setSeite5({
        messungenPV: (data.seite5?.messungenPV ?? Array.from({ length: 5 }, () => ({ ja: false, nein: false, nz: false }))).map(r => ({ ...r })),
        zusatz1: (data.seite5?.zusatz1 ?? Array.from({ length: 5 }, () => ({ zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false }))).map(r => ({ ...r })),
        pruefungGAKs: (data.seite5?.pruefungGAKs ?? Array.from({ length: 13 }, () => ({ ja: false, nein: false, nz: false, sbm: false, sbeiblatt: false }))).map(r => ({ ...r })),
        zusatz2: (data.seite5?.zusatz2 ?? Array.from({ length: 5 }, () => ({ zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false }))).map(r => ({ ...r })),
      });
      setSeite6({
        pruefungWR: (data.seite6?.pruefungWR ?? Array.from({ length: 14 }, () => ({}))).map(r => ({
          ja: r?.ja ?? false,
          nein: r?.nein ?? false,
          nz: r?.nz ?? false
        })),

        zusatzWR: (data.seite6?.zusatzWR ?? Array.from({ length: 5 }, () => ({}))).map(r => ({
          zupunkt: r?.zupunkt ?? "",
          bemerkung: r?.bemerkung ?? "",
          standort: r?.standort ?? "",
          plan: r?.plan ?? false,
          bildnr: r?.bildnr ?? "",
          beh: r?.beh ?? false,
          nbeh: r?.nbeh ?? false
        })),

        pruefungAC: (data.seite6?.pruefungAC ?? Array.from({ length: 13 }, () => ({}))).map(r => ({
          ja: r?.ja ?? false,
          nein: r?.nein ?? false,
          nz: r?.nz ?? false
        })),

        zusatzAC: (data.seite6?.zusatzAC ?? Array.from({ length: 5 }, () => ({}))).map(r => ({
          zupunkt: r?.zupunkt ?? "",
          bemerkung: r?.bemerkung ?? "",
          standort: r?.standort ?? "",
          plan: r?.plan ?? false,
          bildnr: r?.bildnr ?? "",
          beh: r?.beh ?? false,
          nbeh: r?.nbeh ?? false
        })),
      });
      setSeite7(data.seite7);
      setSeite8(data.seite8);
      setSeite9(data.seite9);
      setSeite10(data.seite10);
      setSeite11(data.seite11);
      setSeite11b(data.seite11b);
      setSeite12(data.seite12);
    }

    load();
  }, [id]);



  const speichern = async () => {
    const payload = {
      seite1,
      seite2,
      seite3,
      seite4,
      seite5,
      seite6,
      seite7,
      seite8,
      seite9,
      seite10,
      seite11,
      seite11b,
      seite12
    };

    // 1) SAVE TO BACKEND
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/wartungsprotokoll`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });



    // 👉 HIER
    if (res.ok) {
      alert("Wartungsprotokoll erfolgreich gespeichert!");
      // oder: showSuccess("Erfolg!", "Wartungsprotokoll gespeichert");
    } else {
      alert("Fehler beim Speichern");
    }

  };

  const pdfErstellen = async () => {
    const payload = {
      seite1,
      seite2,
      seite3,
      seite4,
      seite5,
      seite6,
      seite7,
      seite8,
      seite9,
      seite10,
      seite11,
      seite11b,
      seite12
    };

    // Save first
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/wartungsprotokoll`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const saved = await res.json();

    // Generate PDF
    const pdfRes = await fetch(
      `${process.env.REACT_APP_API_URL}/api/wartungsprotokoll/${saved.id}/pdf`
    );

    const blob = await pdfRes.blob();

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Wartungsprotokoll_${saved.id}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };


  return (
    <>
    <div className="space-y-10 mb-10">
<WartungsprotokollSeite1 form={seite1} setForm={setSeite1} speichern={speichern} pdfErstellen={pdfErstellen} />
      <WartungsprotokollSeite2 form={seite2} setForm={setSeite2} />
      <WartungsprotokollSeite3 form={seite3} setForm={setSeite3} />
      <WartungsprotokollSeite4 form={seite4} setForm={setSeite4} />
      <WartungsprotokollSeite5 form={seite5} setForm={setSeite5} />
      <WartungsprotokollSeite6 form={seite6} setForm={setSeite6} />
      <WartungsprotokollSeite7 form={seite7} setForm={setSeite7} />
      <WartungsprotokollSeite8 form={seite8} setForm={setSeite8} />
      <WartungsprotokollSeite9 form={seite9} setForm={setSeite9} />
      <WartungsprotokollSeite10 form={seite10} setForm={setSeite10} />
      <WartungsprotokollSeite11 form={seite11} setForm={setSeite11} />
      <WartungsprotokollSeite11b form={seite11b} setForm={setSeite11b} />
      <WartungsprotokollSeite12 form={seite12} setForm={setSeite12} />
</div>

      {/* Final speichern button here */}
      <button
        style={{
          padding: "10px 20px",
          backgroundColor: "#2B6CB0",
          color: "white",
          borderRadius: "6px",
          border: "none",
          cursor: "pointer",
          marginTop: "40px"
        }}
        onClick={speichern}
      >
        Speichern
      </button>
      <button
        onClick={pdfErstellen}
        style={{
          padding: "10px 20px",
          backgroundColor: "#38A169",
          color: "white",
          borderRadius: "6px",
          border: "none",
          cursor: "pointer",
          marginTop: "40px"
        }}
      >
        PDF Erstellen
      </button>

      <button
        onClick={() => navigate("/dashboard")}
        style={{
          padding: "10px 20px",
          backgroundColor: "#4A5568",
          color: "white",
          borderRadius: "6px",
          border: "none",
          cursor: "pointer",
          marginTop: "40px",
          marginLeft: "10px"
        }}
      >
        Dashboard
      </button>

      <button
        onClick={() => navigate("/wartung/liste")}
        style={{
          padding: "10px 20px",
          backgroundColor: "#805AD5",
          color: "white",
          borderRadius: "6px",
          border: "none",
          cursor: "pointer",
          marginTop: "40px",
          marginLeft: "10px"
        }}
      >
        Wartungsliste
      </button>

      <button
        onClick={() => {
          navigate("/wartung/wartungsprotokoll", { replace: true });
          window.location.reload();
        }}
        style={{
          padding: "10px 20px",
          backgroundColor: "#DD6B20",
          color: "white",
          borderRadius: "6px",
          border: "none",
          cursor: "pointer",
          marginTop: "40px",
          marginLeft: "10px"
        }}
      >
        Neues Wartungsprotokoll
      </button>
    </>
  );
}